import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { session } from '../../../services/session';
import { handleImageError, formatNumber } from '../../base/common/utils';
import linkout from '../../../images/icons/black-linkout.png';
import placeholderImage from '../../../images/logo_placeholder.png';
import searchService from '../trends/search-service';
import { ratesService } from './rates-service';

import InfoModal from './info-modal';
import RetailerInactiveModal from './retailer-inactive-modal';

import './styles/rates-bio.scss';

const RetailerBio = ({ retailer, paymentModels, setShowBio, getRetailer }) => {
  const cartExplorerMerchIds = searchService.merchSlugIds.map(slugId => slugId.merch_id);

  const [displayPaymentModelModal, setDisplayPaymentModelModal] = useState(false);
  const [displayRatesModal, setDisplayRatesModal] = useState(false);
  const [displayInactiveModal, setDisplayInactiveModal] = useState(false);
  const [seeMore, setSeeMore] = useState(false);

  // Active Status
  const activeStatus = retailer.is_in_network ? 'active' : 'inactive';

  // Payment Model Descriptors
  const descriptors = paymentModels[retailer.pricing_model].descriptors.map((descriptor, idx) => {
    return (
      <span key={idx} className="descriptor">
        {descriptor}
      </span>
    );
  });

  // Strategies
  const strategies = retailer.strategic_rate ? (
    <>
      <span className="label">Strategic Rates up to</span>
      <span className="strategic-rate">{retailer.strategic_rate}</span>
    </>
  ) : (
    <span>No Strategies</span>
  );

  // About Section
  const about = retailer.bio ? (
    <div className={`bio ${seeMore ? 'expand' : ''}`}>
      <h2>About {retailer.merchant_name}</h2>
      <div className="content">{retailer.bio}</div>
      <span onClick={() => setSeeMore(!seeMore)}>See {seeMore ? 'less' : 'more'}</span>
    </div>
  ) : null;

  const ratesModal = displayRatesModal ? (
    <InfoModal setDisplayModal={setDisplayRatesModal} modalType="rates" />
  ) : null;

  const paymentModelModal = displayPaymentModelModal ? (
    <InfoModal setDisplayModal={setDisplayPaymentModelModal} modalType="payment-models" />
  ) : null;

  const inactiveModal = displayInactiveModal ? (
    <RetailerInactiveModal
      retailer={retailer}
      setDisplayModal={setDisplayInactiveModal}
      getRetailer={getRetailer}
    />
  ) : null;

  const productInfo = (
    <span>
      <span>
        {`${formatNumber(retailer.sale_items_count)}
				Product${retailer.sale_items_count === 1 ? '' : 's'}`}
      </span>
      <img src={linkout} alt="link out" className="link-out" />
    </span>
  );

  const productLink =
    activeStatus === 'active' ? (
      <Link
        className="sale-items-count"
        to={`/v2/publisher/${session.orgId}/new-recs/product-research?merch_ids=
				${retailer.merch_id}&tab=sale`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {productInfo}
      </Link>
    ) : (
      <div className="sale-items-count">{productInfo}</div>
    );

  const saleItemsCount =
    cartExplorerMerchIds.includes(retailer.merch_id) && retailer.sale_items_count ? (
      <div className="sale-items-count">
        <span className="label">On Sale Now</span>
        {productLink}
      </div>
    ) : null;

  const activitySlider = session.isAdminView ? (
    <div
      onClick={changeRetailActivity}
      className={`slider ${retailer.is_in_network ? 'selected' : ''}`}
    >
      <span />
    </div>
  ) : null;

  function changeRetailActivity() {
    if (retailer.is_in_network) {
      setDisplayInactiveModal(true);
    } else {
      ratesService.updateMerchantPublisherNetwork({
        in_network: true,
        merch_id: retailer.merch_id,
      });
      getRetailer();
    }
  }

  return (
    <>
      <div className="retailer rates-bio">
        <div className={`stats ${activeStatus}`}>
          <div className="toggle">
            <button onClick={() => setShowBio(false)}>Hide</button>
          </div>

          <div className="logo">
            <img
              src={retailer.logo_url || placeholderImage}
              alt={`${retailer.merchant_name || 'retailer'} logo`}
              onError={e => handleImageError(e, placeholderImage)}
            />
          </div>

          <div className="strategies">{strategies}</div>

          <div className="baseline-rate">
            <span className="label">Baseline Rates</span>
            <span className="baseline-rate">{retailer.commission_rate}</span>
          </div>

          {saleItemsCount}

          <span
            className={`modal-toggle ${
              activeStatus === 'active' || !session.isAdminView ? 'active' : ''
            }`}
            onClick={
              activeStatus === 'active' || !session.isAdminView
                ? () => setDisplayRatesModal(true)
                : () => {}
            }
          >
            Learn more about rates
          </span>

          <div className="payment-model">
            <span className="label">{retailer.payment_model.label}</span>
            <div className="descriptors">{descriptors}</div>
            <span
              className={`modal-toggle ${
                activeStatus === 'active' || !session.isAdminView ? 'active' : ''
              }`}
              onClick={
                activeStatus === 'active' || !session.isAdminView
                  ? () => setDisplayPaymentModelModal(true)
                  : () => {}
              }
            >
              Learn more about payment models
            </span>
          </div>

          <div className="activity-container">
            <div className={`active-status ${activeStatus}`}>
              <span>{activeStatus}</span>
            </div>
            {activitySlider}
          </div>
        </div>

        {about}
      </div>

      {ratesModal}

      {paymentModelModal}

      {inactiveModal}
    </>
  );
};

export default RetailerBio;
